document.addEventListener('click', async function (e) {
  const btn = e.target.closest('button[data-membership-cta]');
  if (!btn) return;

    e.preventDefault();

    if (window.rbtMembershipBannerAdding) return;
    window.rbtMembershipBannerAdding = true;


  const variantId = '45090784116806';

  btn.disabled = true;
  btn.textContent = 'Adding...';

  try {
    // Add membership product to cart
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    });

    // Fetch updated cart drawer HTML
    const res = await fetch('/?section_id=cart-drawer');
    const text = await res.text();

    const parser = new DOMParser();
    const doc = parser.parseFromString(text, 'text/html');
    const newDrawer = doc.querySelector('#CartDrawer');
    const currentDrawer = document.querySelector('#CartDrawer');

    if (newDrawer && currentDrawer) {
      currentDrawer.innerHTML = newDrawer.innerHTML;
    }

    // Update cart count bubble
    const bubbleRes = await fetch('/?section_id=cart-icon-bubble');
    const bubbleText = await bubbleRes.text();
    const bubbleDoc = parser.parseFromString(bubbleText, 'text/html');
    const newBubble = bubbleDoc.querySelector('.cart-count-bubble');
    const currentBubble = document.querySelector('.cart-count-bubble');
    if (newBubble && currentBubble) {
      currentBubble.innerHTML = newBubble.innerHTML;
    }

  } catch (err) {
    console.error('Failed to add Redbasil Tru to cart:', err);
    btn.disabled = false;
    btn.textContent = 'Join Redbasil Tru';
  } finally {
      window.rbtMembershipBannerAdding = false;
    }
});
